import { useState } from 'react';

export const useAnalyticsErrors = () => {
  // Error states
  const [pageStatsError, setPageStatsError] = useState<Error | null>(null);
  const [actionStatsError, setActionStatsError] = useState<Error | null>(null);
  const [dailyStatsError, setDailyStatsError] = useState<Error | null>(null);
  const [platformStatsError, setPlatformStatsError] = useState<Error | null>(null);
  const [browserStatsError, setBrowserStatsError] = useState<Error | null>(null);
  const [osStatsError, setOSStatsError] = useState<Error | null>(null);
  const [timeStatsError, setTimeStatsError] = useState<Error | null>(null);
  const [languageStatsError, setLanguageStatsError] = useState<Error | null>(null);
  const [totalStatsError, setTotalStatsError] = useState<Error | null>(null);
  const [referrerStatsError, setReferrerStatsError] = useState<Error | null>(null);
  const [sessionMetricsError, setSessionMetricsError] = useState<Error | null>(null);
  const [exitPagesError, setExitPagesError] = useState<Error | null>(null);
  const [utmStatsError, setUTMStatsError] = useState<Error | null>(null);

  // Computed error states
  const errors = [
    pageStatsError,
    actionStatsError,
    dailyStatsError,
    platformStatsError,
    browserStatsError,
    osStatsError,
    timeStatsError,
    languageStatsError,
    totalStatsError,
    referrerStatsError,
    sessionMetricsError,
    exitPagesError,
    utmStatsError
  ].filter(Boolean);
  
  const hasErrors = errors.length > 0;

  // Reset all errors
  const resetAllErrors = () => {
    setPageStatsError(null);
    setActionStatsError(null);
    setDailyStatsError(null);
    setPlatformStatsError(null);
    setBrowserStatsError(null);
    setOSStatsError(null);
    setTimeStatsError(null);
    setLanguageStatsError(null);
    setTotalStatsError(null);
    setReferrerStatsError(null);
    setSessionMetricsError(null);
    setExitPagesError(null);
    setUTMStatsError(null);
  };

  return {
    // Individual error states
    pageStatsError,
    actionStatsError,
    dailyStatsError,
    platformStatsError,
    browserStatsError,
    osStatsError,
    timeStatsError,
    languageStatsError,
    totalStatsError,
    referrerStatsError,
    sessionMetricsError,
    exitPagesError,
    utmStatsError,
    
    // Computed states
    errors,
    hasErrors,
    
    // Setters
    setPageStatsError,
    setActionStatsError,
    setDailyStatsError,
    setPlatformStatsError,
    setBrowserStatsError,
    setOSStatsError,
    setTimeStatsError,
    setLanguageStatsError,
    setTotalStatsError,
    setReferrerStatsError,
    setSessionMetricsError,
    setExitPagesError,
    setUTMStatsError,
    
    // Functions
    resetAllErrors
  };
};
